var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13439_38280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0.5H0V29.5H29V0.5ZM8.21549 7.5H20.7845C21.6374 7.5 22.4553 7.88619 23.0582 8.57399C23.6613 9.26155 24 10.1942 24 11.1668V18.8332C24 19.8058 23.6613 20.7385 23.0582 21.426C22.4553 22.1138 21.6374 22.5 20.7845 22.5H8.21549C7.36258 22.5 6.54474 22.1138 5.9418 21.426C5.33868 20.7385 5 19.8058 5 18.8332V11.1668C5 10.1942 5.33866 9.26155 5.9418 8.57399C6.54474 7.88621 7.36258 7.5 8.21549 7.5ZM12.6555 18.7768L18.3555 15.4434V15.4467C18.5019 15.3611 18.594 15.1893 18.594 15.0017C18.594 14.814 18.5019 14.6422 18.3555 14.5566L12.6555 11.2233C12.5197 11.1431 12.357 11.1494 12.2263 11.24C12.0954 11.3305 12.0154 11.4923 12.0152 11.6667V18.3334C12.0154 18.5078 12.0954 18.6696 12.2263 18.76C12.357 18.8507 12.5197 18.857 12.6555 18.7768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13439_38280"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a49856778dc0a7b077962e10ff1e7abc.svg";
export { ForwardRef as ReactComponent };